import React from 'react';
import { FeatureContainer } from '../../Containers/FeatureContainer';
import useStyle from './loadingContainer.style';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { classNames } from 'helpers/style/classNames';

export interface LoadingContainerProps {
  status?: boolean;
  variant?:
    | 'default'
    | 'actuQuiz'
    | 'MySkills'
    | 'MyRank'
    | 'MyClass'
    | 'TableMyResult'
    | 'TableMyNotes'
    | 'AvatarChoiceBlock'
    | 'AccountProfile'
    | 'FeatureClassManager'
    | 'faq';
}

export const LoadingContainer = ({
  status = false,
  variant = 'default'
}: LoadingContainerProps) => {
  const classes = useStyle();

  return (
    <>
      {(variant === 'actuQuiz' ||
        variant === 'MySkills' ||
        variant === 'TableMyNotes' ||
        variant === 'AvatarChoiceBlock' ||
        variant === 'AccountProfile' ||
        variant === 'faq') && (
        <div className={classes.header}>
          {variant === 'actuQuiz' && (
            <HeaderText text="Actu quiz" emoji={emojis['LightBulb']} />
          )}
          {variant === 'MySkills' && (
            <HeaderText text="Mes compétences" emoji={emojis['LightBulb']} />
          )}
          {variant === 'TableMyNotes' && (
            <HeaderText
              text="Mes moyennes"
              emoji={emojis['CardIndexDividers']}
            />
          )}
          {variant === 'AvatarChoiceBlock' && (
            <div className={classes.AvatarChoiceBlockHeader}>
              <HeaderText text="Mon avatar" emoji={emojis['CardIndex']} />
              <p>
                Cliquez sur l’avatar de votre choix puis validez pour confirmer
                le changement
              </p>
            </div>
          )}
          {variant === 'AccountProfile' && (
            <HeaderText text="Mon compte" emoji={emojis['CardIndex']} />
          )}
          {variant === 'faq' && (
            <HeaderText text="Liste des questions" emoji={emojis['Books']} />
          )}
        </div>
      )}
      <FeatureContainer>
        <div className={classNames([classes.container, classes[variant]])}>
          <div className={classes.anim}>
            <div className={classes.boxes}>
              <div className={classes.box}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className={classes.box}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className={classes.box}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className={classes.box}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </FeatureContainer>
    </>
  );
};
